export default "__VITE_ASSET__BDHRt$w7__"